import React from "react";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";

const CustomerList = () => {
  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "full_name",
      cell: NACell,
    },
    
    {
      header: "Primary Mobile Number",
      accessorKey: "primary_contact",
      cell: NACell,
    },
    {
      header: "Secondary Mobile Number",
      accessorKey: "secondary_contact",
      cell: NACell,
    },
    {
      header: "VAT/PAN",
      accessorKey: "vat_pan",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: NACell,
    },

    {
      header: "Address",
      accessorKey: "address",
      cell: NACell,
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.CUSTOMER}
        queryKey={"customer"}
        columns={defaultColumns}
        addNewPagePath={"create"}
        tableName={"Customer"}
      />
    </>
  );
};

export default CustomerList;
